import { SitePartRowContextMenuComponentsProps } from "src/tenantCustomizations/TenantCustomizations.ts";
import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { faPaintBrush } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { useConfirmDialog } from "src/components/common/dialogs/confirmDialog/ConfirmDialogContext.ts";
import { SirmetSitePartApi } from "src/api/generated/tenants/sirmet/parts/sirmetSitePartApi.ts";

export const SirmetSitePartRowContextMenuComponents = ({ row, refreshData }: SitePartRowContextMenuComponentsProps) => {
	const confirm = useConfirmDialog();

	if (row.isConfigurable) return null;

	return (
		<AsyncMenuButton
			key={"convertToPaintable"}
			icon={faPaintBrush}
			label={i18n.t("convert_to_paintable")}
			onClick={async () => {
				const confirmed = await confirm();
				if (!confirmed) return;

				await SirmetSitePartApi.convertSitePartToConfigurable({ sitePartId: row.partId });
				await refreshData();
			}}
		/>
	);
};
